import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { storyBlockApi } from '../utils/apiClient';
import Header from '../components/common/Header';
import ContactUs from '../views/landing/ContactUs';
import ClientsSection from '../views/landing/ClientsSection';
import StepsWeFollow from '../views/landing/StepsWeFollow';
import TrustedBySection from '../views/landing/TrustedBySection';
import WhyUs from '../views/landing/WhyUs';
import { imageUrl } from 'src/utils';
import Achievements from 'src/views/landing/Achievments';

const LandingPage = () => {
  const [allBlogs, setAllBlogs] = useState<any[]>([]);
  useEffect(() => {
    fetchAllBlogs();
  }, []);

  const fetchAllBlogs = async () => {
    const response = await storyBlockApi({
      url: 'blogs',
      tag: 'All',
      page: 1,
      viewMore: true,
      all: true,
    });
    setAllBlogs(response?.data?.stories ?? []);
  };
  return (
    <>
      <Helmet>
        <title>Web & App Development Company | Software Consultancy Agency in USA</title>
        <meta
          name="description"
          content="Discover the best web design company in USA offering mobile app development, software consultancy, and comprehensive web & app development solutions."
        />
        <link rel="preload" as="image" href="assets/home-header-hero.svg" />
        <link rel="alternate" hrefLang="en-US" href="https://atinistudio.com/" />
        <link rel="canonical" href="https://atinistudio.com/" />
      </Helmet>
      <Header
        pillLabel="Atini Studio = Code Clinic"
        title={
          <>
            <div>Is Your Software Sick?</div>
            <div className="flex items-center">
              <div>Let Atini Heal</div>
              <img src={imageUrl('heal.svg')} alt="heal" className="w-12 h-12 mx-2" />
              <div>It.</div>
            </div>
          </>
        }
        description="From technical debt and broken features to AI-generated code and legacy systems, we fix what's broken, optimize what's slow, and turn messy codebases into reliable products you can confidently grow."
        image="home-header-hero.svg"
        renderButton
        buttonText="Check My Software"
        altTag="ladder to cup"
      />
      {/* Owns the vertical rhythm for the page: space-y also clears the margins the sections
          set for themselves, so every gap here is the same. pt offsets the hero's own padding. */}
      <div className="space-y-24 breaktwo:space-y-14 pt-12 breaktwo:pt-6 pb-10 breaktwo:pb-6">
        <TrustedBySection />
        <StepsWeFollow />
        <WhyUs />
        <ClientsSection />
        {/* <Achievements /> */}
        <ContactUs />
      </div>
      {allBlogs.map((blog) => (
        <a href={'/' + blog.full_slug}></a>
      ))}
    </>
  );
};

export default LandingPage;
